import styled from 'styled-components';

export const Wrapper = styled.div`
    width: 100%;
	background-color: transparent;
	position: absolute;
	bottom: 0px;
	box-sizing: border-box;
`;